import React from 'react';

import { motion } from 'framer-motion';
import { useScroll } from '../helpers/scrollAnimations';

import { parent, childern, fade } from '../helpers/animation';

const Home = () => {
	const [element, controls] = useScroll();

	return (
		<motion.div
			variants={fade}
			id="home"
			className="section home"
			ref={element}
			animate={controls}
		>
			<motion.div variants={parent} initial="hidden" animate="visible">
				<div className="title-wrapper">
					<h1>Hello, I am Jivan.</h1>
				</div>
				<div className="inline">
					<motion.li variants={childern}>I'm a </motion.li>
					<span className="yellow">
						<motion.li
							whileHover={{
								scale: [1, 0.9, 0.9, 1.1, 1],
								transition: {
									duration: 0.3,
								},
							}}
							variants={childern}
						>
							{' '}
							Front-End
						</motion.li>
					</span>
					<span className="yellow">
						<motion.li
							whileHover={{
								scale: [1, 0.9, 0.9, 1.1, 1],
								transition: {
									duration: 0.3,
								},
							}}
							variants={childern}
						>
							{' '}
							web developer.
						</motion.li>
					</span>
				</div>
			</motion.div>
		</motion.div>
	);
};

export default Home;
